import { ChartBinSize, ChartDefinition, ChartKey, ChartQueryParam, ChartRendererType } from '@frontend/chart/types';
import { Application, Feature } from '@frontend/functionality/types';

import { TRANSACTION_VOLUME_CHART_ENDPOINT } from '../../transaction-chart-endpoints';

export const VENDING_REPLENISHMENT_TRANSACTION_VOLUME_HOUR_DAY_HEATMAP_CHART_DEFINITION: ChartDefinition = {
    key: ChartKey.VENDING_REPLENISHMENT_TRANSACTION_VOLUME_HOUR_DAY_HEATMAP,
    chartType: ChartRendererType.HEATMAP,
    endpoint: TRANSACTION_VOLUME_CHART_ENDPOINT,
    filters: [
        { key: ChartQueryParam.APPLICATION, value: Application.VENDING },
        { key: ChartQueryParam.FEATURE, value: Feature.INBOUND_TRANSACTION },
        { key: ChartQueryParam.STATE, value: 'transaction_completed' },
        { key: ChartQueryParam.BIN_SIZE, value: ChartBinSize.HOUR }
    ]
};
